import { UpgradeContextType } from "@zenith/context/global-context/types";
import { TierStepsResponseDTO } from "@zenith/services/user";

/**
 * Updates the step status of each tier, according to the response from the back-end.
 * @function
 * @name updateTierStepStatus
 * @kind function
 * @param {UpgradeContextType} upgradeContext The upgrade Context.
 * @param {TierStepsResponseDTO.stepName} stepName The step name.
 * @param {TierStepsResponseDTO.stepStatus} stepStatus The step status.
 * @returns {TierStepsResponseDTO[]} The updated tier steps.
 * @exports
 */
export function updateTierStepStatus(
  upgradeContext: UpgradeContextType,
  stepName: TierStepsResponseDTO.stepName,
  stepStatus: TierStepsResponseDTO.stepStatus
): TierStepsResponseDTO[] {
  const tierStepsUpdated: TierStepsResponseDTO[] = [];

  upgradeContext.tierSteps?.forEach((tierStep) => {
    if (tierStep.stepName === stepName) {
      tierStepsUpdated.push({
        ...tierStep,
        stepStatus: stepStatus,
      });
    } else {
      tierStepsUpdated.push(tierStep);
    }
  });

  return tierStepsUpdated;
}
